<template>
  <div class="uk-container">
    <div class="uk-card uk-card-default uk-width-large uk-margin-auto">
      <div class="uk-card-header uk-text-center">
        <h3 class="uk-card-title">New Enquiry</h3>
        <p class="uk-text-meta">Create a new enquiry. <span uk-tooltip="Help text for enquiry."><i class="icon gg-info" /></span></p>
      </div>
      <div class="uk-card-body">
        <ValidationObserver ref="observer-enquiry" tag="div" class="uk-form-stacked">
          <div class="uk-margin">
            <ValidationProvider v-slot="{ errors }">
              <label class="uk-form-label uk-text-bold" for="name-first" :class="{ 'uk-text-danger': errors.length }">First Name</label>
              <div class="uk-form-controls">
                <input id="name-first" v-model="name.first" class="uk-input" :class="{ 'uk-form-danger': errors.length }" type="text" name="name-first">
              </div>
              <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>

          <div class="uk-margin">
            <ValidationProvider v-slot="{ errors }">
              <label class="uk-form-label uk-text-bold" for="name-last" :class="{ 'uk-text-danger': errors.length }">Last Name</label>
              <div class="uk-form-controls">
                <input id="name-last" v-model="name.last" class="uk-input" :class="{ 'uk-form-danger': errors.length }" type="text" name="name-last">
              </div>
              <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>

          <div class="uk-margin">
            <ValidationProvider v-slot="{ errors }">
              <label class="uk-form-label uk-text-bold" for="contact-phone" :class="{ 'uk-text-danger': errors.length }">Phone</label>
              <div class="uk-form-controls">
                <input id="contact-phone" v-model="contact.phone" class="uk-input" :class="{ 'uk-form-danger': errors.length }" type="text" name="contact-phone">
              </div>
              <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>

          <div class="uk-margin">
            <ValidationProvider v-slot="{ errors }" rules="email">
              <label class="uk-form-label uk-text-bold" for="contact-email" :class="{ 'uk-text-danger': errors.length }">Email</label>
              <div class="uk-form-controls">
                <input id="contact-email" v-model="contact.email" class="uk-input" :class="{ 'uk-form-danger': errors.length }" type="text" name="contact-email">
              </div>
              <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>

          <div class="uk-margin">
            <ValidationProvider v-slot="{ errors }">
              <label class="uk-form-label uk-text-bold" for="contact-notes" :class="{ 'uk-text-danger': errors.length }">Contact Notes</label>
              <div class="uk-form-controls">
                <textarea id="contact-notes" v-model="contact.notes" class="uk-textarea" :class="{ 'uk-form-danger': errors.length }" type="text" name="contact-notes" rows="7" />
              </div>
              <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>

          <div class="uk-margin">
            <ValidationProvider v-slot="{ errors }">
              <label class="uk-form-label uk-text-bold" for="location-area" :class="{ 'uk-text-danger': errors.length }">Area</label>
              <div class="uk-form-controls">
                <multiselect id="location-area" v-model="location.area" :class="{ 'multiselect-error': errors.length }" placeholder="Pick one. Type to filter." label="name" track-by="uid" :options="$helpers.areas" :searchable="true" />
              </div>
              <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>

          <div class="uk-margin">
            <ValidationProvider v-slot="{ errors }">
              <label class="uk-form-label uk-text-bold" for="location-customer" :class="{ 'uk-text-danger': errors.length }">Customer Location <span class="uk-text-normal">(Postcode)</span></label>
              <div class="uk-form-controls">
                <input id="location-customer" v-model="location.customer" class="uk-input" :class="{ 'uk-form-danger': errors.length }" type="text" name="location-customer">
              </div>
              <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>

          <div class="uk-margin">
            <ValidationProvider v-slot="{ errors }">
              <label class="uk-form-label uk-text-bold" for="source" :class="{ 'uk-text-danger': errors.length }">Source <span class="uk-text-normal">(How did they found us?)</span></label>
              <div class="uk-form-controls">
                <multiselect id="source" v-model="source" :class="{ 'multiselect-error': errors.length }" placeholder="Pick one. Type to filter." label="value" track-by="id" :options="$helpers.channels" :searchable="true" />
              </div>
              <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>

          <div class="uk-margin">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <label class="uk-form-label uk-text-bold" for="details" :class="{ 'uk-text-danger': errors.length }">Details *</label>
              <div class="uk-form-controls">
                <textarea id="details" v-model="details" class="uk-textarea" :class="{ 'uk-form-danger': errors.length }" type="text" name="details" rows="7" />
              </div>
              <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>

          <div class="uk-margin">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <label class="uk-form-label uk-text-bold" for="status" :class="{ 'uk-text-danger': errors.length }">Status *</label>
              <div class="uk-form-controls">
                <select id="status" v-model="status" class="uk-select" :class="{ 'uk-form-danger': errors.length }" name="status">
                  <template v-for="item in $helpers.status.enquiry.filter(s => s.id !== 'new')">
                    <option :key="item.id" :value="item.id">{{ item.value }}</option>
                  </template>
                </select>
              </div>
              <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
        </ValidationObserver>
      </div>
      <div class="uk-card-footer uk-text-center">
        <button class="uk-button uk-button-primary" @click="submit">Submit Enquiry</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  name: 'ViewEnquiryCreate',

  components: {
    ValidationProvider,
    ValidationObserver
  },


  data() {
    return {
      name: {
        first: null,
        last: null
      },
      contact: {
        phone: null,
        email: null,
        notes: null
      },
      location: {
        area: null,
        customer: null
      },
      source: null,
      details: null,
      status: null
    }
  },

  methods: {
    async submit() {
      const isValid = await this.$refs['observer-enquiry'].validate()

      if (isValid) {
        const enquiry = {
          content: {
            name: {
              first: this.name.first,
              last: this.name.last
            },
            contact: {
              phone: this.contact.phone,
              email: this.contact.email,
              notes: this.contact.notes
            },
            location: {
              area: (this.location.area) ? this.location.area.uid : null,
              customer: this.location.customer
            },
            source: (this.source) ? this.source.id : null,
            details: this.details
          },
          info: {
            created: {
              timestamp: this.$firebase.firestore.FieldValue.serverTimestamp(),
              user: this.$store.state.account.record.uid
            },
            status: this.status
          },
          log: [{
            timestamp: this.$firebase.firestore.Timestamp.now(),
            user: this.$store.state.account.record.uid,
            type: 'create',
            content: this.status
          }]
        }

        try {
          await this.$firebase.firestore().collection(this.$globals.firebase.collection.enquiries).add(enquiry)
          this.$uikit.notification('Enquiry was submitted successfully!', 'success')

          this.name.first = null
          this.name.last = null
          this.contact.phone = null
          this.contact.email = null
          this.contact.notes = null
          this.location.area = null
          this.location.customer = null
          this.source = null
          this.details = null
          this.status = null

          this.$refs['observer-enquiry'].reset()
        } catch (error) {
          console.log(error)
          this.$uikit.notification('Something went wrong while submitting the enquiry. <br> Please try again later, or contact support if the problem persists.', 'danger')
        }
      }
    }
  }
}
</script>
